/*
 * Copyright 2020-2023 Aion Technology LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import 'zone.js/plugins/zone-error';
import {EnvironmentOptions} from './environment-options';

const windowEnv = window as EnvironmentOptions;

export const environment = {
  production: windowEnv?.env?.production,
  region: windowEnv?.env?.region,
  apiUri: windowEnv?.env?.apiUri,
  lpgUri: windowEnv?.env?.lpgUri,
  baseUri: windowEnv?.env?.baseUri,
  cognitoPoolId: windowEnv?.env?.cognitoPoolId,
  cognitoClientId: windowEnv?.env?.cognitoClientId
};
